export default function ReportActivityFeedIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="6.10352e-05" width="28" height="28" rx="14" fill="#4FCC88" />
      <path
        d="M21.9608 11.0037C19.8444 8.87012 17.0053 7.70007 13.9942 7.70007C10.983 7.70007 8.14397 8.87012 6.02756 11.0037C5.76946 11.2618 5.76946 11.7092 6.02756 11.9673C6.28566 12.2254 6.73303 12.2254 6.99113 11.9673C8.84944 10.0918 11.3444 9.05939 13.9942 9.05939C16.644 9.05939 19.139 10.0918 20.9973 11.9673C21.1349 12.105 21.307 12.1738 21.4791 12.1738C21.6511 12.1738 21.8232 12.105 21.9608 11.9673C22.2361 11.692 22.2361 11.2618 21.9608 11.0037Z"
        fill="white"
      />
      <path
        d="M8.17893 13.1548C7.92083 13.4129 7.92083 13.8603 8.17893 14.1184C8.43702 14.3765 8.88439 14.3765 9.14249 14.1184C11.8095 11.4514 16.1628 11.4514 18.8298 14.1184C18.9674 14.2561 19.1395 14.3249 19.3116 14.3249C19.4836 14.3249 19.6557 14.2561 19.7934 14.1184C20.0515 13.8603 20.0515 13.4129 19.7934 13.1548C16.5929 9.95441 11.3966 9.95441 8.17893 13.1548Z"
        fill="white"
      />
      <path
        d="M13.9937 13.8256C12.6172 13.8256 11.3267 14.359 10.3459 15.3398C10.0878 15.5979 10.0878 16.0453 10.3459 16.3034C10.604 16.5615 11.0514 16.5615 11.3095 16.3034C12.0322 15.5807 12.9785 15.1849 13.9937 15.1849C15.0089 15.1849 15.9553 15.5807 16.6779 16.3034C16.8156 16.441 16.9877 16.5098 17.1597 16.5098C17.3318 16.5098 17.5038 16.441 17.6415 16.3034C17.8996 16.0453 17.8996 15.5979 17.6415 15.3398C16.6607 14.359 15.3702 13.8256 13.9937 13.8256Z"
        fill="white"
      />
      <path
        d="M13.999 17.1514C13.2091 17.1514 12.5566 17.8039 12.5566 18.5938C12.5566 19.4008 13.2091 20.0534 13.999 20.0534C14.8061 20.0534 15.4586 19.4008 15.4586 18.5938C15.4586 17.8039 14.8061 17.1514 13.999 17.1514Z"
        fill="white"
      />
    </svg>
  );
}
